// eslint-disable-next-line import/prefer-default-export
export const DispatchEngine = Object.freeze({
  IC2: 'IC2',
  MK: 'MK', // Mobile Knowledge
});
